import React, { useState, useEffect } from 'react'; 
import { fetchHotels } from '../../API/fetchHotels';
import { fetchFactureOrganismes } from '../../API/fetchFactureOrganismes';
import { checkPassportExistence } from '../../API/checkPassportExisting';
import { addClient } from '../../API/ajouterClient';
import { AjouterReservation } from '../../API/ajouterreservation';
import { fetchReservations } from '../../API/retrievereservations';
import { fetchRoomsHotelFacture } from '../../API/fetchRoomsHotelFacture'; 
import { EditReservation } from '../../API/updatereservation';
import { fetchIDReservation } from '../../API/fetchIdReservation';

import { factClientCheck } from '../../Functions/factClientCheck';
import { getFormattedDate } from '../../Functions/currentDateFacture';
import { checkReservationOverlap } from '../../Functions/checkReservationOverlap';
import { formatedDBDate } from '../../Functions/convertDate';

import '../../Css/ReservationTable.css';

const ReservationTable = ({ onSubmitReserv }) => {
  const [organisme, setOrganisme] = useState([]);
  const [selectedorganisme, setSelectedorganisme] = useState('');
  const [hotelList, setHotelList] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState('');
  const [roomList, setRoomList] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(''); 
  const [BCReference, setBCReference] = useState(''); 
  const [pension, setPension] = useState(''); 
  const [observations, setObservations] = useState(''); 
  const [currentDate, setCurrentDate] = useState('');
  const [reservationclients, setReservationclients] = useState([{
    passport: '',
    clientName: '',
    checkInDate: '',
    checkOutDate: '',
    BCReference: "",
    reservationStatus: ''
  }]);
  const [reservationData, setReservationData] = useState([]);
  const [notification, setNotification] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [reservationFilters, setReservationFilters] = useState({
      id:"",
      id_reservation: "",
      selectedorganisme: "",
      selectedHotel: "",
      selectedRoom: "",
      pension: "",
      observations: "",
      currentDate: "",
      passport: "",
      clientName: "",
      checkInDate: "",
      checkOutDate: "",
      BCReference: "",
      reservationStatus: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [selectedReservation, setSelectedReservation] = useState(null);
    const [files, setFiles] = useState([]);
    const [fileUrls, setFileUrls] = useState([]);
    const [docUrls, setDocUrls] = useState([]);
    const [overlapMessage, setOverlapMessage] = useState([]);
    const [errorPassport, setErrorPassport] = useState('');

    const token = localStorage.getItem('token');
    const apiUrl = process.env.REACT_APP_API_URL;

/*Retrieve hotel list*/
  useEffect(() => {
    const fetchHotelData = async () => {
      const data = await fetchHotels();
      console.log("fetchHotelData",data);
      setHotelList(data);
    };
    fetchHotelData();
  }, []);

/*Retrieve organisme list*/
  useEffect(() => {
    const fetchOrganismeData = async () => {
      const data = await fetchFactureOrganismes();
      console.log("fetchOrganismeData",data);
      setOrganisme(data);
    };
    fetchOrganismeData();
  }, []);

/*Retrieve current date*/
  useEffect(() => {
    if (!currentDate) {
      getFormattedDate(setCurrentDate);
    }
  }, []);

  const fetchReservationsData = async () => {
    try {
      const data = await fetchReservations();
      console.log("fetchReservationssss",data);

      setReservationData([...data]);
    } catch (error) {
      console.error('Failed to fetch reservations', error);
    } finally {
      setLoading(false);
    }
  };

//Retrieve reservations records
  useEffect(() => {
    fetchReservationsData();
  }, []);

/*Retrieve room by hotel */
  useEffect(() => {
    const fetchRoomData = async () => {
      const data = await fetchRoomsHotelFacture(selectedHotel); 

      console.log("fetchRoomsHotelFacture",data);
      setRoomList(data); 
    };
    fetchRoomData();
  }, [selectedHotel]);

  const handleAddClient = () => {
    setReservationclients([...reservationclients, { passport: '', clientName: '', checkInDate: '', checkOutDate: '', reservationStatus: "", documentUrl:"" }]);
  };

  const handleRemoveClient = async (index) => {
    const updatedClients = reservationclients.filter((_, i) => i !== index);
    setReservationclients(updatedClients);
    await checkReservationOverlap(updatedClients, setOverlapMessage);
  };

  const handleIputDataChange = async (index, field, value) => {
    const updatedData = [...reservationclients];
    updatedData[index][field] = value;

    await checkReservationOverlap(updatedData, setOverlapMessage);

    let checkIn=updatedData[index].checkInDate;
    let checkOut=updatedData[index].checkOutDate;

    const passporto = updatedData[index].passport;
  
    if (field === 'passport' ) {
          factClientCheck(updatedData,setNotification, setErrorPassport);
    }

    if (field === 'checkInDate' || field === 'checkOutDate') {
      const today = new Date();
      const todayFormatted = today.toISOString().split('T')[0];  
  
      if (checkOut <= todayFormatted) {
        updatedData[index].reservationStatus = 'Check-Out';
      } 
      else if (checkIn > todayFormatted) {
        updatedData[index].reservationStatus = 'Confirmée';
      } 
      else if (checkIn <= todayFormatted) {
        updatedData[index].reservationStatus = 'Check-In';
      }

      let checkInDate = updatedData[index].checkInDate;
      let checkOutDate = updatedData[index].checkOutDate;

      if(checkInDate && checkOutDate){
        if(checkInDate > checkOutDate){
          alert('La date dventrée ne peut pas etre supérieur à la date de sortie');
          updatedData[index].checkInDate = '';
          updatedData[index].checkOutDate = '';
        }
      }
    }

    setReservationclients([...updatedData]);
  };

  const handleHotelChange = (event) => {
    setSelectedHotel(event.target.value);
  };

  const handleOrganismeChange = (event) => {
    setSelectedorganisme(event.target.value);
    //getFormattedDate(setCurrentDate);
  };

  const handleRoomlChange = (event) => {
    setSelectedRoom(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const factClientData = reservationclients.map(({ passport, clientName }) => ({
      passport,
      clientName,
    }));

    let doclink = { fileUrls: [], originalFileNames: [] };

    if (fileUrls.length !== 0){
      doclink = await uploadDocuments();
    }

    let IDReservation = await fetchIDReservation();
    
    const Reservation = {
      id_reservation: IDReservation,
      reservationclients,
      selectedorganisme,
      selectedHotel,
      selectedRoom,
      BCReference,
      pension,
      observations,
      currentDate,
      docUrls: doclink.fileUrls,
      filenames: doclink.originalFileNames
    };


    console.log("Reservationnnnn",Reservation);

    try {
      await AjouterReservation(Reservation);
      for (const client of factClientData) {
        const clientExists = await checkPassportExistence(client.passport);
        if (!clientExists) {
          await addClient(client);
        }
      }
      fetchReservationsData();
      alert(`Reservation created successfully ${IDReservation}`);
      resetForm();
      setFileUrls('');
      setDocUrls('');
      setOverlapMessage('');
      onSubmitReserv();
    } catch (error) {
      console.error('Failed to submit reservation:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditReservation = (reserve) => {
    window.scrollTo(0, 0);
    setIsEditing(true);
    setSelectedReservation(reserve.id); 
    setSelectedorganisme(reserve.selectedorganisme);
    setSelectedHotel(reserve.selectedHotel);
    setSelectedRoom(reserve.selectedRoom);
    setPension(reserve.pension);
    setObservations(reserve.observations);
    setDocUrls(reserve.docUrls);
  
    setReservationclients(
      reserve.clients.map(client => ({
        passport: client.passport,
        clientName: client.clientName,
        checkInDate: formatedDBDate(client.checkInDate),
        checkOutDate: formatedDBDate(client.checkOutDate),
        BCReference: client.BCReference,
        reservationStatus: client.reservationStatus
      }))
    );   
    
    fetchReservations();
  };

  function formatDateTime(isoDate) {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
  
    return `${year}-${month}-${day} | ${hours}:${minutes}:${seconds}`;
  }
  
  const handleUpdateReservation = async (e) => {
    e.preventDefault();

    setLoading(true);

    const updatedReservation = {
        selectedorganisme,
        selectedHotel,
        selectedRoom,
        pension,
        BCReference,
        observations,
        reservationclients
    };

    try {
        const response = await EditReservation(selectedReservation, updatedReservation);
        alert('Reservation updated successfully!');
        setIsEditing(false);
        resetForm();
        fetchReservationsData();
        setOverlapMessage('');
    } catch (error) {
        console.error('Error updating reservation:', error);
        setNotification('Error updating reservation.');
        alert('Failed to update reservation.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    resetForm();
  };

  const resetForm = () => {
    setReservationclients([{
      passport: '',
      clientName: '',
      checkInDate: '',
      checkOutDate: '',
      BCReference: '',
      reservationStatus: ''
    }]);
    setSelectedorganisme('');
    setSelectedHotel('');
    setSelectedRoom('');
    setBCReference('');
    setPension('');
    setObservations('');
    setCurrentDate('');
  };

  const handleFileChange = async (e) => {
    const files = e.target.files;

    if (files.length > 0) {
      const formData = new FormData();
      const newFiles = [];
      const maxFileSize = 5 * 1024 * 1024; 

      for (let file of files) {
        if (file.type === "application/pdf") {
          if (file.size > maxFileSize) {
            alert("File is too large. Please upload a file smaller than 5 MB.");
            e.target.value = ""; 
            return; 
          }
          formData.append("files", file);
          newFiles.push(file);
        } else {
          alert("Please upload only JPEG files.");
          e.target.value = ""; 
          return; 
        }
      }
      setFileUrls((prevFiles) => [...prevFiles, ...newFiles]);
      e.target.value = ""; 
    }
  };

  const uploadDocuments = async () => {
    try {
      const formData = new FormData();

      for (let file of fileUrls) {
        formData.append("files", file);
      }

      const response = await fetch(`${apiUrl}/api/upload/reservation-file`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`, 
        },
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        return {
          fileUrls: data.fileUrls,
          originalFileNames: data.originalFileNames
        };
      } else {
        alert("File upload failed");
      }
      
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Error uploading file");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveFilee = (index) => {
    setFileUrls((prevDocUrls) => prevDocUrls.filter((_, i) => i !== index));
  };

  const handleRemoveFile = async (index) => {
    const fileUrl = docUrls[index];

    try {
      const response = await fetch(`${apiUrl}/api/delete/reservation-file`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ fileUrl }),
      });

      if (response.ok) {
        setDocUrls((prevDocUrls) => prevDocUrls.filter((_, i) => i !== index));
      } else {
        alert("Failed to delete the file on the server.");
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      alert("Error deleting file");
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return <div className='ReservationTable__error-api'>Error: {error}</div>;
  }
  
  return (
    <div className="ReservationTable__page">
      <div className="ReservationTable__container">
        <h2 className="Facturetablie__title">Gestion des Réservations</h2>

        <form onSubmit={handleSubmit} className="ReservationTable__form">
          {/* Organisme Select */}
          <div className='ReservationTable__flex-block'>
            <div className="ReservationTable__form-group">
              <label>Organisme:</label>
              <select
                name="organisme"
                value={selectedorganisme}
                onChange={handleOrganismeChange}
                required
              >
                <option value="" disabled>اختر الموؤسسة</option>
                {organisme.map((org, index) => (
                  <option key={index} value={org.title}>{org.title}</option>
                ))}
              </select>
            </div>

            {/* Hotel Select */}
            <div className="ReservationTable__form-group">
              <label>Hotel:</label>
              <select
                name="hotels"
                value={selectedHotel}
                onChange={handleHotelChange}
                required
              >
                <option value="" disabled>اختر النزل</option>
                {hotelList.map((hotel, index) => (
                  <option key={index} value={hotel.nameHotel}>{hotel.nameHotel}</option>
                ))}
              </select>
            </div>

            {/* Room Select */}
            <div className="ReservationTable__form-group">
              <label>Chambre:</label>
              <select
                name="rooms"
                value={selectedRoom}
                onChange={handleRoomlChange}
                required
              >
                <option value="" disabled>اختر الغرفة</option>
                {roomList.map((room, index) => (
                  <option key={index} value={room.room}>{room.room}</option>
                ))}
              </select>
            </div>

            {/* Pension Select */}
            <div className="ReservationTable__form-group">
              <label>Arrangement:</label>
              <select
                name="pension"
                value={pension}
                onChange={(e) => setPension(e.target.value)}
                required
              >
                <option value="" disabled>اختر نوع الاقامة</option>
                <option value="اقامة مع فطور صباح">اقامة مع فطور صباح</option>
                <option value="نصف اقامة">نصف اقامة</option>
                <option value="اقامة كاملة">اقامة كاملة</option>
              </select>
            </div>
          </div>


        {Array.isArray(notification) && notification.length > 0 && (
          <div>
            {notification.map((msg, idx) => (
              <p key={idx} style={{ color: 'green', whiteSpace: 'pre-line' }}>
                {msg}
              </p>
            ))}
          </div>
        )}


       {Array.isArray(errorMsg) && errorMsg.length > 0 && (
          <div>
            {errorMsg.map((msg, idx) => (
              <p key={idx} style={{ color: 'red', whiteSpace: 'pre-line' }}>
                {msg}
              </p>
            ))}
          </div>
        )}


        {Array.isArray(overlapMessage) && overlapMessage.length > 0 && (
          <div>
            {overlapMessage.map((msg, idx) => (
              <p key={idx} style={{ color: 'red', whiteSpace: 'pre-line' }}>
                {msg}
              </p>
            ))}
          </div>
        )}

          {reservationclients.length === 0 && handleAddClient()}
          {reservationclients.map((client, index) => (
            <div key={index} className="ReservationTable__form-grid">
              <div className="ReservationTable__form-group2">
                <label>Passport:</label>
                <input
                  type="text"
                  name="passport"
                  value={client.passport}
                  onChange={(e) => handleIputDataChange(index, 'passport', e.target.value.toUpperCase())}
                  required
                />
              </div>
              <div className="ReservationTable__form-group2">
                <label>Nom du Client:</label>
                <input
                  type="text"
                  name="clientName"
                  value={client.clientName}
                  onChange={(e) => handleIputDataChange(index, 'clientName', e.target.value)}
                  required
                />
              </div>
              <div className="ReservationTable__form-group2">
                <label>Check In:</label>
                <input
                  type="date"
                  name="checkInDate"
                  value={client.checkInDate}
                  onChange={(e) => handleIputDataChange(index, 'checkInDate', e.target.value)}
                  required
                />
              </div>
              <div className="ReservationTable__form-group2">
                <label>Check Out:</label>
                <input
                  type="date"
                  name="checkOutDate"
                  value={client.checkOutDate}
                  onChange={(e) => handleIputDataChange(index, 'checkOutDate', e.target.value)}
                  required
                />
              </div>
              <div className="ReservationTable__form-group2">
                <label>B.C# ref:</label>
                <input
                  type="text"
                  name="BCReference"
                  value={client.BCReference}
                  onChange={(e) => handleIputDataChange(index, 'BCReference', e.target.value)}
                />
              </div>
              {isEditing ? (
                <div className="ReservationTable__form-group2">
                  <label>Statut</label>
                  <select
                    name="reservationStatus"
                    value={client.reservationStatus}
                    onChange={(e) => handleIputDataChange(index, 'reservationStatus', e.target.value)}
                  >
                    <option value="">{client.reservationStatus}</option>
                    <option value="annulée">Annulée</option>
                  </select>
                </div>
              ) : null}

              {reservationclients.length > 1 && (
                <div className="ReservationTable__form-group2">
                <button
                  type="button"
                  className="ReservationTable__remove-client-btn"
                  onClick={() => handleRemoveClient(index)}
                >
                  Supprimer
                </button>
              </div>
              )}
            </div>
          ))}

          <button type="button" className="ReservationTable__add-client-btn" onClick={handleAddClient}>
            Ajouter Client
          </button>

          <div className="ReservationTable__form-group3">
            <label>Commentaire</label>
            <input
              name="Commentaire"
              type="text"
              placeholder="write something here ...."
              value={observations}
              onChange={(e) => setObservations(e.target.value)}
              rows="2"
              cols="2"
            />
          </div>

          {!isEditing && (
            <div className="ReservationTable__file-form-group">
              <label>Joindre le document (PDF uniquement):</label>
              <input
                type="file"
                name="document"
                accept=".pdf"
                multiple
                onChange={handleFileChange}
              />
            </div>
          )}

          <div>
              {fileUrls.length > 0 && (
                <div>
                  <h4>Uploaded Files</h4>
                  <ul className='ReservationTable__fileurls'>
                    {fileUrls.map((file, index) => (
                      <li key={index}>
                        {file.name}{" "}
                        <button type="button" className="ReservationTable__delete-file" onClick={() => handleRemoveFilee(index)}>
                          Delete
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
          </div>

          <div className="ReservationTable__submit-btn-container">
              <button type="submit" className="ReservationTable__submit-btn">
                Ajouter Réservation
              </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReservationTable;